<app-dialog
  [title]=data.title
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    { text: 'Save'}
  ]"
  (action)="action($event)"
  (close)="close()"
>
<div class="current-checkbox">
    <mat-checkbox [checked]="isRemoveStock" [(ngModel)]="isRemoveStock">Remove current stock</mat-checkbox>
</div>

</app-dialog>